import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './app';
import reportWebVitals from './report-web-vitals';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "https://efe9f2bf877e19df9303f3ce6da75015@o4510844287975424.ingest.de.sentry.io/4511558410174544",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions; adjust in production as needed
  // Session Replay
  replaysSessionSampleRate: 0.1, // Save 10% of sessions for replays
  replaysOnErrorSampleRate: 1.0, // Save 100% of sessions that end with errors
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div style={{ padding: "20px", textAlign: "center", fontFamily: "sans-serif" }}>
        <h2>Oops! Something went wrong.</h2>
        <p>Our team has been notified. Please try reloading the page.</p>
      </div>
    }>
      <App />
    </Sentry.ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
